document.addEventListener("DOMContentLoaded", function() {

  // Pop-up "Ce produit contient"
  function getPopUpContient() {
    return document.querySelector('.pop-up-product.pop-up-produit-contient');
  }

  function openPopUpContient() {
    var pop_up = getPopUpContient();
    if (pop_up) {
      pop_up.style.cssText = "display: block;";
      setTimeout(function () {
        pop_up.classList.add("open");
      }, 0);
    }
  }

  function closePopUpContient() {
    var pop_up = getPopUpContient();
    if (pop_up) {
      pop_up.classList.remove("open");
      setTimeout(function () {
        pop_up.style.cssText = "display: none;";
      }, 540);
    }
  }
  
  function getPopUp() {
    return document.querySelector('.pop-up-product.pop-up-variants');
  }

  function openPopUp() {
    var pop_up = getPopUp();
    if (pop_up) {
      pop_up.style.cssText = "display: block;";
      setTimeout(function () {
        pop_up.classList.add("open");
      }, 0);
    }
  }

  function closePopUp() {
    var pop_up = getPopUp();
    if (pop_up) {
      pop_up.classList.remove("open");
      setTimeout(function () {
        pop_up.style.cssText = "display: none;";
      }, 540);
    }
  }

  // Cacher les filtres couleur uniques par order
  function hideUniqueFiltres() {
    var items = document.querySelectorAll('.container-pop-up__liste-variants > li[style]');
    var orderCount = {};
    
    // Compter les occurrences de chaque order
    items.forEach(function(item) {
      var styleValue = item.getAttribute('style');
      var orderMatch = styleValue.match(/order:\s*(\d+)/);
      if (orderMatch) {
        var orderValue = orderMatch[1];
        orderCount[orderValue] = (orderCount[orderValue] || 0) + 1;
      }
    });
    
    // Cacher les éléments dont l'order n'apparaît qu'une fois (sauf 99)
    items.forEach(function(item) {
      var styleValue = item.getAttribute('style');
      var orderMatch = styleValue.match(/order:\s*(\d+)/);
      if (orderMatch) {
        var orderValue = orderMatch[1];
        if (orderCount[orderValue] === 1 && orderValue !== '99') {
          item.remove();
        }
      }
    });
  }

  // Délégation d'événements sur document
  document.addEventListener('click', function(event) {
    var pop_up = getPopUp();
    var pop_up_contient = getPopUpContient();

    // Clique sur "+ 100 choix"
    if (event.target.closest('.sec__main-product .block-product__variant-picker .plus-de-choix')) {
      if (pop_up && pop_up.classList.contains("open")) {
        closePopUp();
      } else {
        openPopUp();
      }
      return;
    }

    // Fermer le pop-up
    if (event.target.closest('.pop-up-product.pop-up-variants .container-pop-up__close') || 
        event.target.closest('.pop-up-product.pop-up-variants .modal-overlay')) {
      closePopUp();
      return;
    }

    // Fermer via overlay
    if (event.target.closest('.pop-up-product.pop-up-produit-contient .modal-overlay')) {
      closePopUpContient();
      return;
    }

    // Clique sur une couleur dans le pop-up
    var couleurItem = event.target.closest('.pop-up-product .container-pop-up .container-pop-up__liste-variants li.couleur');
    if (couleurItem && pop_up) {
      var selectedColor = couleurItem.getAttribute("color");
      
      // Retirer .active de l'ancien et ajouter sur le nouveau
      var activeColor = pop_up.querySelector('li.couleur.active');
      if (activeColor) {
        activeColor.classList.remove("active");
      }
      couleurItem.classList.add("active");
      
      // Sélectionner le label correspondant
      var correspondingLabel = document.querySelector('.variant-swatch-color .swatch-color .color-swatch-label[aria-label="'+ selectedColor +'"]');
      if (correspondingLabel) {
        correspondingLabel.click();
      }

      // Fermer le pop-up
      if (pop_up) {
        pop_up.classList.remove("open");
        setTimeout(function () {
          pop_up.style.cssText = "display: none;";
        }, 540);
      }

      return;
    }

    // Sélection des couleurs depuis les swatches
    var colorLabel = event.target.closest('.variant-swatch-color .swatch-color .color-swatch-label');
    if (colorLabel && pop_up) {
      var selectedColor = colorLabel.getAttribute("aria-label");
      var activeColor = pop_up.querySelector('li.couleur.active');
      if (activeColor) {
        activeColor.classList.remove("active");
      }
      var newActiveColor = pop_up.querySelector('li.couleur[color="'+ selectedColor +'"]');
      if (newActiveColor) {
        newActiveColor.classList.add("active");
      }

        if (colorLabel && pop_up_contient){
            for (var i = 0; i < pop_up_contient.querySelectorAll('.produit-couleur').length; i++) {
                pop_up_contient.querySelectorAll('.produit-couleur')[i].textContent = selectedColor;
            }
        }
    }

    // Clique sur "+ de choix" produit contient
    if (event.target.closest('.sec__main-product .block-product__pack-products .plus-de-choix')) {
      if (pop_up_contient && pop_up_contient.classList.contains("open")) {
        closePopUpContient();
      } else {
        openPopUpContient();
      }
      return;
    }

    // Fermer le pop-up produit contient
    if (event.target.closest('.pop-up-product.pop-up-produit-contient .container-pop-up__close')) {
      closePopUpContient();
      return;
    }
  });

  // Initialisation de la couleur active au chargement
  function initActiveColor() {
    var pop_up = getPopUp();
    var checkedLabel = document.querySelector('.variant-swatch-color .swatch-color .variant-options:checked+.color-swatch-label');
    if (pop_up && checkedLabel) {
      var first_active_color = checkedLabel.getAttribute("aria-label");
      var colorItem = pop_up.querySelector('li.couleur[color="'+ first_active_color +'"]');
      if (colorItem) {
        colorItem.classList.add("active");
      }
      var titleColorBlock = document.querySelector('.sec__main-product .block-product__variant-picker .heading-style');
      if (titleColorBlock){
        pop_up.querySelector('.container-pop-up__header .container-pop-up__titre').textContent = titleColorBlock.textContent;
      }
      var pop_up_contient = getPopUpContient();
      if (pop_up_contient){
        for (var i = 0; i < pop_up_contient.querySelectorAll('.produit-couleur').length; i++) {
            pop_up_contient.querySelectorAll('.produit-couleur')[i].textContent = first_active_color;
        }
      }
    }
    
  }

  var pop_up_contient = getPopUpContient();
  var packProductsTitle = document.querySelector('.sec__main-product .block-product__pack-products .title');
  if (packProductsTitle && pop_up_contient){
    pop_up_contient.querySelector('.container-pop-up__titre').textContent = packProductsTitle.textContent;
  }

  initActiveColor();
  hideUniqueFiltres();

  // Réinitialiser après rechargement AJAX de Shopify
  document.addEventListener('shopify:section:load', function() {
    initActiveColor();
    hideUniqueFiltres();
  });
});